import styled from 'styled-components';

const TransactionHistoryContentWrapper = styled.div`
  margin: 0 auto;
  width: 100%;

  // increasing padding to BackLink componnet on Transaction History page
  a {
    padding-bottom: 40px;
  }
`;

const TransactionHistoryWrapper = styled.div`
  align-content: center;
  background-color: ${(props) => props.theme.color.neutral.v200};
  box-shadow: rgb(24 53 88 / 10%) 1px 2px 3px 1px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  font-family: 'Brandon Text';
  padding: 10px 24px 46px;
  max-width: 1800px;
  margin: 0 auto;

  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    padding: 10px 32px 46px;
  }

  @media (min-width: ${(props) => props.theme.breakpoint.lg}px) {
    padding-bottom: 40px;
  }
`;

const SpinnerWrapper = styled.div`
  display: flex;
  min-height: 500px;
`;

const TransactionHistoryCardWrapper = styled.div`
  align-content: center;
  border-radius: ${(props) => props.theme.border.radius};
  background-color: ${(props) => props.theme.color.neutral.v100};
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  font-family: 'Brandon Text';
  justify-content: center;
  padding: 25px;
  box-shadow: 0px 2px 3px rgba(25, 41, 61, 0.13);
  width: 100%;
  height: 100%;
  margin: 0 auto;

  @media (min-width: ${(props) => props.theme.breakpoint.sm}px) {
    min-width: 325px;
    justify-content: flex-start;
  }

  @media (max-width: ${(props) => props.theme.breakpoint.sm}px) {
    min-height: 410px;
  }

  @media (min-width: ${(props) => props.theme.breakpoint.lg}px) {
    min-height: auto;
    padding: 40px;
  }

  @media (min-width: ${(props) => props.theme.breakpoint.xl}px) {
    max-width: 1060px;
    min-height: 320px;
  }
`;

const TransactionHistoryTitle = styled.h2`
  color: ${(props) => props.theme.color.primary.v600};
  padding: 0 0 30px;
  margin: 0;
  font-size: 28px;
`;

export {
  TransactionHistoryContentWrapper,
  TransactionHistoryWrapper,
  SpinnerWrapper,
  TransactionHistoryCardWrapper,
  TransactionHistoryTitle,
};
